import React from 'react';
import PropTypes from 'prop-types';
// import EditIcon from '@material-ui/core/svg-icons/editor/mode-edit';
import Icon from '@projeccions-pdc/react-icon';
// import Avatar from '@material-ui/core/Avatar';
import { isAdminOrEditor } from '../../../helpers';
import LocalizedStrings from '../../Localization/localization';
import './NotificationsList.css';

const CreateNotification = ({ handleNewNotification, customizationStyle }) => {
    return (
        <div
            className={`btn compose ${customizationStyle.primaryBackgroundColor}`}
            style={{
                verticalAlign: 'middle',
                position: 'relative'
                //backgroundColor: '#009fc4',
            }}
            data-id="new-notification-btn"
        >
            <div
                onClick={handleNewNotification}
                style={{
                    verticalAlign: 'middle',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50%)'
                }}
            >
                <Icon name="md-mode-edit" size={'15px'} primaryColor={'#fff'} />
                {` ${LocalizedStrings.createNotification}`}
            </div>
        </div>
    );
};
CreateNotification.propTypes = {
    handleNewNotification: PropTypes.func.isRequired,
    customizationStyle: PropTypes.object.isRequired
};

const NotificationsList = ({
    notifications,
    onNotificationSelected,
    selectedNotificationId,
    handleNewNotification,
    customizationStyle,
    isSmartphone
}) => {
    let isAdmin = isAdminOrEditor();
    if (notifications === undefined || notifications.length === 0) {
        return (
            <div className={`notification-list empty ${isSmartphone === true ? 'smartphone' : ''}`}>
                {isAdmin === true ? (
                    <CreateNotification
                        handleNewNotification={handleNewNotification}
                        customizationStyle={customizationStyle}
                    />
                ) :
                    ('')
                }
                {/* <div className={`btn compose ${customizationStyle.primaryBackgroundColor}`} style={{
                    verticalAlign: 'middle',
                    position: 'relative',
                    //backgroundColor: '#009fc4',
                }}>
                    <div onClick={handleNewNotification} style={{ verticalAlign: 'middle', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', }}>
                        <EditIcon style={{ width: '15px', height: '15px', color: '#fff' }} />
                        {' Create a Notification'}
                    </div>
                </div> */}
                <div style={{ padding: '10px', paddingTop: '150px' }}>
                    {LocalizedStrings.noNotifications}
                </div>
            </div>
        );
    } else {
        notifications.sort((a, b) => {
            if (a.dateCreated < b.dateCreated) return -1;
            if (a.dateCreated > b.dateCreated) return 1;
            return 0;
        });
        notifications.reverse();
    }
    return (
        <div className={`notification-list ${isSmartphone === true ? 'smartphone' : ''}`}>
            {isAdmin === true ? (
                <CreateNotification
                    handleNewNotification={handleNewNotification}
                    customizationStyle={customizationStyle}
                />
            ) : ('')
            }
            {notifications.map((notification, i) => {
                return (
                    <NotificationsListItem
                        key={'notification' + i}
                        onNotificationClicked={onNotificationSelected}
                        notification={notification}
                        selected={
                            selectedNotificationId === notification.messageId
                        }
                        customizationStyle={customizationStyle}
                    />
                );
            })}
        </div>
    );
};
NotificationsList.propTypes = {
    notifications: PropTypes.array.isRequired,
    onNotificationSelected: PropTypes.func.isRequired,
    selectedNotificationId: PropTypes.string,
    handleNewNotification: PropTypes.func.isRequired,
    customizationStyle: PropTypes.object.isRequired,
    isSmartphone: PropTypes.bool.isRequired,
};

const NotificationsListItem = ({
    notification,
    onNotificationClicked,
    selected,
    customizationStyle
}) => {
    let classes = 'notification-item';
    if (selected) {
        classes += ' selected'; //+ customizationStyle.primaryColor;
    }

    return (
        <div
            onClick={() => {
                onNotificationClicked(notification.messageId);
            }}
            className={classes}
            data-id={notification.messageId}
        >
            {/* <Avatar
                src={notification.avatar}
                size={40}
                backgroundColor={'#fff'}
                style={{ margin: 0, display: 'inline-block', position: 'absolute', top: 15, bottom: 15 }}
            /> */}
            {notification.status === 'new' ? (
                <div
                    className={`notification-item__unread-dot ${customizationStyle.primaryBackgroundColor}`}
                //style={{ background: '#009fc4', }}
                />
            ) : ('')
            }
            <div className="notification-item__subject truncate">
                {notification.title}
            </div>
            <div className="notification-item__details">
                {/* <span className='notification-item__from truncate'>{notification.from}</span> */}
                <span className="notification-item__time truncate">
                    {new Date(notification.dateCreated).toLocaleString()}
                </span>
            </div>
        </div>
    );
};
NotificationsListItem.propTypes = {
    notification: PropTypes.object.isRequired,
    onNotificationClicked: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
    customizationStyle: PropTypes.object.isRequired
};

export default NotificationsList;
